import React from 'react';
import { Carousel as AntdCarousel } from 'antd';
import img1 from './images/carousel-image-1.jpg';
import img2 from './images/carousel-image-2.jpg';
import img3 from './images/carousel-image-3.jpg';
import styles from './Carousel.module.css';

export const Carousel: React.FC = () => {
  return (
    <AntdCarousel autoplay>
      {[img1, img2, img3].map(img => (
        <div key={img}>
          <div
            style={{ backgroundImage: `url(${img})` }}
            className={styles.image}
          ></div>
        </div>
      ))}
    </AntdCarousel>
  );
};
